// extracted by mini-css-extract-plugin
export default {"productsPage":"ProductsPage_productsPage__XlMlP","banner":"ProductsPage_banner__ecrKt"};